import {
  ADD_ADITIONAL_EFORMS,
  CHANGE_EFORMS,
  DELETE_PICKUP,
  EDIT_PICKUP,
  SET_EFORM_SELECTED,
  SET_EFORM_TEMPLATES,
  SET_ENABLE_PICKUP,
  SET_INITIAL_EFORM_AUTOCOMPLETE,
  SET_INITIAL_EFORM_CREATE,
  SET_INITIAL_EFORM_JWT,
  SET_INITIAL_EFORMS,
  SET_INITIAL_FOLDERS,
  SET_INITIAL_TOTAL,
  SET_INITIAL_URL_S3,
  UPDATE_NONPICKUP_EFORM
} from "./mutations-types";
import Eforms from '@/apiClient/Eforms'
import Folder from '@/apiClient/Folders'
import Pickup from '@/apiClient/Pickup'
import { forEach } from "lodash";

const ef = new Eforms()
const dir = new Folder()
const pk = new Pickup()

const actions = {
  setInitialEforms: async ({ commit }, payload) => {

    return new Promise((resolve, reject) => {
      ef.getTemplateList(payload).then(response => {
        let { total, data: eforms, eforms: { jwt, eformCreate, eformAutocompleteFields, urlLogo } } = response.data

        forEach(eforms, (obj, index) => {
          if(obj.hasOwnProperty('config')) {
            delete obj.config
          }
          eforms[index] = obj
        })

        commit(SET_INITIAL_TOTAL, total)

        commit(SET_INITIAL_EFORMS, eforms)

        commit(SET_INITIAL_EFORM_JWT, jwt)

        commit(SET_INITIAL_EFORM_CREATE, eformCreate)

        commit(SET_INITIAL_EFORM_AUTOCOMPLETE, eformAutocompleteFields)

        commit(SET_INITIAL_URL_S3, urlLogo)
        // commit(SET_INITIAL_EFORM_PAIS, pais)

        commit('SET_LOADING', false, { root: true })
      }).catch(error => {
        reject(error)
      })
    })
  },
  setEformTemplates: async ({ commit }, payload) => {
    const { data } = await ef.getEformTemplates()
    removeConfig(data.results.data)
    commit(SET_EFORM_TEMPLATES, data.results)
  },
  addAditionalEforms: async ({ commit }, payload) => {
    const { data } = await ef.getTemplateList(payload)

    const { data: eforms } = data
    forEach(eforms, (obj, index) => {
      if(obj.hasOwnProperty('config')) {
        delete obj.config
      }
      eforms[index] = obj
    })
    commit(ADD_ADITIONAL_EFORMS, eforms)
  },
  filterByNameOrStatus: async ({ commit }, payload) => {
    commit(CHANGE_EFORMS)
    const { data } = await ef.getTemplateList(payload)
    const { total } = data
    forEach(total, (obj, index) => {
      if(obj.hasOwnProperty('config')) {
        delete obj.config
      }
      total[index] = obj
    })

    commit(SET_INITIAL_TOTAL, total)
  },
  setEformSelected: async ({ commit }, payload) => {
    commit(SET_EFORM_SELECTED, payload)
  },

  setInitialFolders: async ({ commit }, payload) => {
    const query = { "filters": '{"where":[{"operator":"eq","alias":"formato","value":"eform"}]}' }
    const { data: { results: { data } } } = await dir.getDocumentTypeAvailable(query)
    commit(SET_INITIAL_FOLDERS, data)
  },

  enablePickup: async ({ commit }, payload) => {
    const { data: { results: { data } } } = await pk.enablePickup({
      idtemplate: payload.id,
      nombre: payload.nombre,
      requires_approval: payload.required_approval,
      id_categoria_tipo_documento: payload.idCarpeta,
      certificate: payload.certificate
    }).catch(e => {
      throw e.response
    })
    commit(SET_ENABLE_PICKUP, { eform: payload, idpickupform: data.id })
  },

  deletePickup: async ({ commit }, payload) => {
    await pk.deletePickup({ id: payload }).catch(e => {
      throw e.response
    })

    commit(DELETE_PICKUP, payload)
  },

  editPickup: async ({ commit }, payload) => {
    const doc = {
      nombre: payload.nombre,
      requires_approval: payload.required_approval,
      id_categoria_tipo_documento: payload.idCarpeta,
      estado: payload.estadoText,
      certificate: payload.certificate
    }

    await pk.editPickup({
      id: payload.idpickupform,
      doc
    }).catch(e => {
      throw e.response
    })

    commit(EDIT_PICKUP, payload)
  },

  editNonPickup: async ({ commit }, payload) => {

    const doc = {
      iddoc: payload.id,
      nombre: payload.nombre,
      estado: payload.estadoText
    }

    await ef.updateEform(doc).catch(e => {
      throw e.response
    })

    commit(UPDATE_NONPICKUP_EFORM, payload)
  }
}
function removeConfig(data) {
  return forEach(data, (obj, index) => {
    if (obj.hasOwnProperty('templates')) {
      forEach(obj.templates, template => {
        delete template.config
      })
    }
    return obj
  })
}

export default actions
